import { type GivingBase, GivingTypeEnum } from 'models';
import { useTranslation } from 'react-i18next';
import { DataCard, HandHeartLineIcon } from 'ui';
import { images } from 'common/utils';
import { useGivingTypeOptions } from '../../hooks';

type P = {
  getPathToGivingDetail: (id: string) => string;
  giving: GivingBase;
  showTag?: boolean;
};

const GivingCard = ({ getPathToGivingDetail, giving, showTag = true }: P) => {
  const { getTranslate } = useGivingTypeOptions();
  const { t } = useTranslation();
  const isParticipantsVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.DONATION;
  const isPriceVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.OFFERING;

  return (
    <DataCard
      className="giving-card"
      description={giving.endTime ? { dateFrom: giving.startTime, dateTo: giving.endTime } : undefined}
      image={{
        alt: 'Giving cover image',
        src: giving.coverPhoto?.url ?? images.default.givingCoverPhoto,
      }}
      participantsProperties={
        isParticipantsVisible
          ? {
              count: giving.giversCount,
              label: (formattedMembersCount) =>
                t('formattedDonorsCount', { count: giving.giversCount, formattedCount: formattedMembersCount }),
            }
          : undefined
      }
      path={getPathToGivingDetail(giving.id)}
      pricesProperties={
        isPriceVisible && giving.amountTotal
          ? {
              currentPrice: giving.amountTotal,
              label: 'Raised',
              textType: 'success',
            }
          : undefined
      }
      progressProperties={
        giving.amountGoal
          ? { color: 'success', max: giving.amountGoal, size: 'extra-small', value: giving.amountTotal }
          : undefined
      }
      tag={showTag ? { children: getTranslate(giving.type), color: 'orange', icon: <HandHeartLineIcon /> } : undefined}
      title={giving.name}
    />
  );
};

export default GivingCard;
